import { findPermissionTab } from "../config/helpers";
const user = JSON.parse(localStorage.getItem("user"));

const Policies = {
  UserPolicy: findPermissionTab(user?.privileges, "users")?.actions,

  SubAdminPolicy: findPermissionTab(user?.privileges, "sub-admins")?.actions,

  SupplierPolicy: findPermissionTab(user?.privileges, "suppliers")?.actions,

  ListingPolicy: findPermissionTab(user?.privileges, "listing")?.actions,

  ProductGroupPolicy: findPermissionTab(user?.privileges, "product-groups")
    ?.actions,

  InsuranceCompanyPolicy: findPermissionTab(
    user?.privileges,
    "insurance-companies"
  )?.actions,

  SelectPolicy: findPermissionTab(user?.privileges, "selects")?.actions,

  OrderPolicy: findPermissionTab(user?.privileges, "orders")?.actions,

  BannerPolicy: findPermissionTab(user?.privileges, "banners")?.actions,

  PromotionPolicy: findPermissionTab(user?.privileges, "promotions")?.actions,

  CouponPolicy: findPermissionTab(user?.privileges, "coupons")?.actions,

  RatingPolicy: findPermissionTab(user?.privileges, "ratings")?.actions,

  NotificationPolicy: findPermissionTab(user?.privileges, "notifications")
    ?.actions,

  PaymentPolicy: findPermissionTab(user?.privileges, "payments")?.actions,

  AccountingPolicy: findPermissionTab(user?.privileges, "accounting")?.actions,

  ReportPolicy: findPermissionTab(user?.privileges, "reports")?.actions,

  SettingPolicy: findPermissionTab(user?.privileges, "settings")?.actions,

  CtegoryPolicy: findPermissionTab(user?.privileges, "categories")?.actions,

  SubCategoryPolicy: findPermissionTab(user?.privileges, "sub-categories")
    ?.actions,

  BrandPolicy: findPermissionTab(user?.privileges, "brands")?.actions,

  ProductPolicy: findPermissionTab(user?.privileges, "products")?.actions,
  BlogPolicy: findPermissionTab(user?.privileges, "coupons")?.actions, // TODO
};

export default Policies;
